import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';


import milk from "../images/milk.jpg";
import buffaloMilk from "../images/22.jpeg";
import freshPaneer from "../images/1.jpg";
import pureGhee from "../images/5.jpg";
import freshButter from "../images/Picture3.jpg";
import flavoredMilk from "../images/milk.jpg";
import freshCurd from "../images/23.jpeg";
import greekYogurt from "../images/9.jpeg";

import manpower from "../images/20.jpg";
import SHG_Training from "../images/15.jpg";

import testing from "../images/12.jpeg";
import center from "../images/Stall.jpg";
import Village from "../images/11.jpeg";
import Outlet from "../images/7.jpg";


 






import Quality_Assurance from "../images/16.jpg";

const Gallery = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      id: 1,
      src: milk,
      title: 'Fresh Cow Milk',
      category: 'Products',
      description: 'Pure, farm-fresh cow milk with high nutritional value'
    },
    {
      id: 2,
      src: buffaloMilk,
      title: 'Buffalo Milk',
      category: 'Products',
      description: 'Creamy buffalo milk perfect for traditional preparations'
    },
    {
      id: 3,
      src: freshPaneer,
      title: 'Fresh Paneer',
      category: 'Products',
      description: 'Homemade paneer from pure milk, soft and nutritious'
    },
    {
      id: 4,
      src: pureGhee,
      title: 'Pure Ghee',
      category: 'Products',
      description: 'Traditional pure ghee made from cow milk'
    },
    {
      id: 5,
      src: greekYogurt,
      title: 'Fresh Yogurt',
      category: 'Products',
      description: 'Creamy fresh yogurt with live cultures'
    },
    {
      id: 6,
      src: freshButter,
      title: 'Fresh Butter',
      category: 'Products',
      description: 'Creamy homemade butter from fresh cream'
    },
    {
      id: 7,
      src: manpower,
      title: 'Women Empowerment',
      category: 'Community',
      description: 'Rural women working together in dairy entrepreneurship'
    },
    {
      id: 8,
      src: SHG_Training,
      title: 'SHG Training',
      category: 'Training',
      description: 'Capacity building programs for SHG members'
    },
    {
      id: 9,
      src: testing,
      title: 'Quality Testing',
      category: 'Technology',
      description: 'IoT milk analyzer for quality testing and fair pricing'
    },
    {
      id: 10,
      src: center,
      title: 'Collection Center',
      category: 'Infrastructure',
      description: 'Milk collection and processing facilities'
    },
    {
      id: 11,
      src: Village,
      title: 'Village Operations',
      category: 'Community',
      description: 'Daily operations in rural village settings'
    },
    {
      id: 12,
      src: Outlet,
      title: 'Retail Outlet',
      category: 'Infrastructure',
      description: 'WiSE retail outlets serving local communities'
    }
  ];

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const categories = ['All', 'Products', 'Community', 'Training', 'Technology', 'Infrastructure'];
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredImages = activeCategory === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section className="py-5 text-white hero_sec" style={{ background: 'linear-gradient(135deg, #2E8B57, #4682B4)' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">Image Gallery</h1>
              <p className="fs-5">Explore our journey through images - from dairy products to community empowerment</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Category Filter */}
      <section className="py-4" style={{ backgroundColor: '#f8f9fa' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <div className="d-flex flex-wrap justify-content-center gap-2">
                {categories.map((category, index) => (
                  <button
                    key={index}
                    className={`btn ${activeCategory === category ? 'btn-primary' : 'btn-outline-primary'} btn-sm`}
                    onClick={() => setActiveCategory(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Gallery Grid */}
      <section className="section-padding">
        <Container>
          <Row>
            {filteredImages.map((image) => (
              <Col lg={3} md={4} sm={6} key={image.id} className="mb-4">
                <div 
                  className="gallery-item position-relative overflow-hidden rounded shadow hover-lift"
                  onClick={() => handleImageClick(image)}
                  style={{ cursor: 'pointer', height: '250px' }}
                >
                  <img 
                    src={image.src} 
                    alt={image.title}
                    className="w-100 h-100"
                    style={{ objectFit: 'cover', transition: 'transform 0.3s ease' }}
                  />
                  <div className="gallery-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end p-3"
                       style={{ 
                         background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                         opacity: 0,
                         transition: 'opacity 0.3s ease'
                       }}>
                    <div className="text-white">
                      <h6 className="fw-bold mb-1">{image.title}</h6>
                      <small>{image.category}</small>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Lightbox Modal */}
      <Modal 
        show={showModal} 
        onHide={handleCloseModal} 
        size="lg" 
        centered
        className="gallery-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>{selectedImage?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {selectedImage && (
            <div>
              <img 
                src={selectedImage.src} 
                alt={selectedImage.title}
                className="w-100"
                style={{ maxHeight: '70vh', objectFit: 'contain' }}
              />
              <div className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h5 className="fw-bold">{selectedImage.title}</h5>
                  <span className="badge bg-primary">{selectedImage.category}</span>
                </div>
                <p className="text-muted">{selectedImage.description}</p>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Gallery Stats */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="fw-bold mb-4">Our Visual Journey</h2>
              <Row>
                <Col md={3} className="mb-3">
                  <div className="bg-white p-4 rounded shadow-sm">
                    <div className="display-6 fw-bold text-primary">{galleryImages.length}</div>
                    <p className="small text-muted mb-0">Total Images</p>
                  </div>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="bg-white p-4 rounded shadow-sm">
                    <div className="display-6 fw-bold text-success">8+</div>
                    <p className="small text-muted mb-0">Dairy Products</p>
                  </div>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="bg-white p-4 rounded shadow-sm">
                    <div className="display-6 fw-bold text-info">5+</div>
                    <p className="small text-muted mb-0">Villages Covered</p>
                  </div>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="bg-white p-4 rounded shadow-sm">
                    <div className="display-6 fw-bold text-warning">65+</div>
                    <p className="small text-muted mb-0">SHG Members</p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Gallery;